export default __webpack_public_path__ + "static/media/eye-closed.4dcf2876.png";